<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
      </b-col>
    </b-row>

    <b-row v-if="quote">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de la Proforma</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="2">
                <strong>Correlativo:</strong>
                <p>{{ quote.correlative }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Documento del Cliente:</strong>
                <p>{{ quote.clientDni }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Cliente:</strong>
                <p>{{ quote.clientName }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Proforma realizada por:</strong>
                <p>
                  {{
                    quote.registerBy ? quote.registerBy.fullname : "No asignado"
                  }}
                </p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Establecimiento Origen:</strong>
                <p>
                  {{
                    quote.establishmentOrigin
                      ? quote.establishmentOrigin.name
                      : "No disponible"
                  }}
                </p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Tipo de Moneda:</strong>
                <p>{{ quote.currencyType }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalle de la Proforma</h4>
          </b-card-header>
          <b-card-text>
            <b-table
              :items="quotationDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="quotationDetails.length > 0">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Resumen de costos</h4>
          </b-card-header>
          <b-card-text class="mb-1">
            <b-table
              small
              :items="calculatedItems"
              :fields="summary"
              responsive
              hover
              show-empty
              empty-text="No existe"
            >
              <template #cell(unitPrice)="data">
                {{ currencySymbol }} {{ data.item.unitPrice }}
              </template>
              <template #cell(cost)="data">
                {{ currencySymbol }} {{ data.item.cost }}
              </template>
            </b-table>
            <b-row class="mt-3">
              <b-col
                class="text-right font-weight-bold"
                style="font-size: 1.25rem"
              >
                Total:
              </b-col>
              <b-col
                class="text-left text-primary font-weight-bold"
                style="font-size: 1.5rem"
              >
                {{ currencySymbol }} {{ totalCost.toFixed(2) }}
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import QuoteService from "@/services/QuoteService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      quote: null,
      quotationDetails: [],
      fields: [
        {
          key: "autopart.uniqueCode",
          label: "Código Único",
          sortable: true,
        },
        {
          key: "autopart.originalCode",
          label: "Código Original",
          sortable: true,
        },
        { key: "autopart.alterCode", label: "Código Alterno", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: true },
        { key: "unitPrice", label: "Precio Unitario", sortable: true },
      ],
      summary: [
        { key: "uniqueCode", label: "Código Único" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "cost", label: "Costo (Cantidad x Precio)" },
      ],
    };
  },
  mounted() {
    this.getQuoteDetails();
  },
  computed: {
    currencySymbol() {
      return this.quote?.currencyType === "Dólar" ? "$" : "S/";
    },
    calculatedItems() {
      return this.quotationDetails.map((item) => ({
        description: item.autopart.description,
        uniqueCode: item.autopart.uniqueCode,
        quantity: item.qty,
        unitPrice: parseFloat(item.unitPrice).toFixed(2),
        cost: (parseFloat(item.qty) * parseFloat(item.unitPrice)).toFixed(2),
      }));
    },
    totalCost() {
      return this.quotationDetails.reduce((sum, item) => {
        return sum + parseFloat(item.qty) * parseFloat(item.unitPrice);
      }, 0);
    },
  },
  methods: {
    async getQuoteDetails() {
      try {
        const quoteId = this.$route.params.id;
        const store = this.$store;
        const response = await QuoteService.getQuoteById(quoteId, store);

        if (response && response.statusCode === 200 && response.data) {
          this.quote = response.data.quote;
          this.quotationDetails = response.data.quoteDetails;
        } else {
          this.$swal(
            "Error",
            "No se encontraron detalles de la proforma.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al obtener la proforma:", error);
        this.$swal(
          "Error",
          "Ocurrió un problema al cargar los detalles de la proforma.",
          "error"
        );
      }
    },
  },
};
</script>
